<template>
  <div class="app-container post-template-list">
    <basic-container>
      <avue-crud ref="crud"
        :page.sync="page"
        :data="tableData"
        :table-loading="tableLoading"
        :option="tableOption"
        @search-reset="searchReset"
        @search-change="searchChange"
        @current-change="currentChange"
        @size-change="sizeChange"
        @sort-change="sortChange"
        @refresh-change="refreshChange"
        >
        <template slot="search">
          <el-form-item label="分类">
            <el-select
              size="small"
              v-model="listQuery.tagId"
              >
              <el-option
                v-for="item in tagOptions"
                :key="item.tagId"
                :label="item.tagName"
                :value="item.tagId"
                >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="主题">
            <el-select
              size="small"
              v-model="listQuery.themeTagId"
              >
              <el-option
                v-for="item in themeTagOptions"
                :key="item.themeTagId"
                :label="item.themeTagName"
                :value="item.themeTagId"
                >
              </el-option>
            </el-select>
          </el-form-item>
        </template>
        <template slot="menuLeft">
          <el-button type="primary"
            v-if="permissions.post_template_add"
            size="mini"
            @click="handleAdd">创建</el-button>
        </template>
        <template slot="menu" slot-scope="scope">
          <el-button type="text"
            v-if="permissions.post_template_view"
            icon="el-icon-view"
            size="mini"
            plain
            @click="handleView(scope.row,scope.index)">查看</el-button>
          <el-button type="text"
            v-if="permissions.post_template_edit"
            icon="el-icon-edit"
            size="mini"
            plain
            @click="handleEdit(scope.row,scope.index)">编辑</el-button>
          <el-button type="text"
            v-if="permissions.post_template_delete"
            icon="el-icon-delete"
            size="mini"
            plain
            @click="handleDelete(scope.row,scope.index)">删除</el-button>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>
<script>
import { tableOption } from '@/const/crud/setting/template/postTemplate'
import { fetchList, delObj } from '@/api/setting/template/postTemplate'
import { getTagsByType } from '@/api/basic/tagtype'
import { mapGetters } from 'vuex'
import { themeTagTypeId } from '@/config/const';

export default {
  data () {
    return {
      page: {
        currentPage: 1,
        pageSize: 20,
        total: 0
      },
      tableData: [],
      tableLoading: false,
      tableOption: tableOption,
      listQuery: {
        current: 1,
        size: 20,
        sortField: 'inserted_time',
        sortPolicy: 'desc',
        tagId: '',
        name: '',
        themeTagId: '',
      },
      tagOptions: [],
      themeTagOptions: []
    }
  },
  computed: {
    ...mapGetters(['permissions'])
  },
  mounted () {
    this.getList()
    this.getTagOptions()
    this.getThemeTagOptions()
  },
  methods: {
    getParams () {
      let params = {
        current: this.listQuery.current,
        size: this.listQuery.size,
        sortField: this.listQuery.sortField,
        sortPolicy: this.listQuery.sortPolicy
      }
      if (this.listQuery.name) {
        params.name = this.listQuery.name
      }
      if (this.listQuery.tagId) {
        params.tagId = this.listQuery.tagId
      }
      if (this.listQuery.themeTagId) {
        params.themeTagId = this.listQuery.themeTagId
      }
      return params
    },
    getList () {
      this.tableLoading = true
      fetchList(this.getParams()).then(response => {
        this.tableData = this.formatData(response.data.data.records)
        this.page.total = response.data.data.total
        this.tableLoading = false
      }).catch(error => {
        this.$message({
          message: '获取帖子模板失败',
          type: 'error'
        })
        this.tableLoading = false
      })
    },
    formatData (records) {
      if (records && records.length > 0) {
          records.forEach(function(record, index) {
            if (!record.themeTagName) { record.themeTagName = "--" }
          })
        }
      return records
    },
    getTagOptions () {
      getTagsByType({
        type: 2
      }).then(response => {
        this.tagOptions = this.formatTagData(response.data.data)
      }).catch(error => {
        console.error(error)
        this.$message({
          message: '获取帖子分类失败',
          type: 'error'
        })
      })
    },
    getThemeTagOptions () {
      getTagsByType({
        type: themeTagTypeId
      }).then(response => {
        this.themeTagOptions = this.formatThemeTagData(response.data.data)
      }).catch(error => {
        console.error(error)
        this.$message({
          message: '获取帖子主题失败',
          type: 'error'
        })
      })
    },
    formatThemeTagData (tags) {
      if (Array.isArray(tags)) {
        return tags.map(x => {
          return {
            themeTagId: x.id,
            themeTagName: x.name
          }
        })
      } else {
        return []
      }
    },
    formatTagData (tags) {
      if (Array.isArray(tags)) {
        return tags.map(x => {
          return {
            tagId: x.id,
            tagName: x.name
          }
        })
      } else {
        return []
      }
    },
    searchReset () {
      this.listQuery.name = ''
      this.listQuery.tagId = ''
      this.listQuery.themeTagId = ''
      this.searchChange({})
    },
    searchChange (params) {
      this.page.currentPage = 1
      this.listQuery.current = 1
      this.listQuery.name = params.name
      this.getList()
    },
    currentChange (val) {
      this.page.currentPage = val
      this.listQuery.current = val
      this.getList()
    },
    sizeChange (val) {
      this.page.currentPage = 1
      this.listQuery.current = 1
      this.page.pageSize = val
      this.listQuery.size = val
      this.getList()
    },
    sortChange (val) {
      // 检查排序对象
      if (val.prop == "id") {
        this.listQuery.sortField = "id"
      } else if (val.prop == "insertedTime") {
        this.listQuery.sortField = "inserted_time"
      }
      // 检查排序方式
      if (val.order == 'ascending') {
        this.listQuery.sortPolicy = "asc"
      } else if (val.order == 'descending') {
        this.listQuery.sortPolicy = "desc"
      } else {
        this.listQuery.sortPolicy = ""
      }
      this.getList()
    },
    refreshChange () {
      this.getList()
    },
    handleAdd () {
      this.$router.push({
        path: '/setting/template/post/add'
      })
    },
    handleView (row, index) {
      this.$router.push({
        path: `/setting/template/post/detail/${row.id}`
      })
    },
    handleEdit (row, index) {
      this.$router.push({
        path: `/setting/template/post/edit/${row.id}`,
      })
    },
    handleDelete (row, index) {
      this.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delObj(row.id).then(response => {
          if (response.data.data) {
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.getList()
          }
        }).catch(error => {
          console.error(error)
          this.$message({
            message: '删除失败',
            type: 'error'
          })
        })
      })
    }
  }
}
</script>

